import { useEffect, useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import Bugsnag from '@bugsnag/js';

import { findData } from 'services/findCEP';
import PessoaFisicaForm from 'pages/RegisterUpdate/pessoa-fisica';
import { Header } from 'components/Header';

import * as CXT from 'context/globalContext';
import * as S from './styles';
import {
  validateEstoqueAndCustomer,
  postPedido,
} from '../../utils/propostaUtils';
import CpfCnpjInputSection from 'pages/RegisterUpdate/components/CpfCnpjInputSection';
import { TitleWrapperAvalistaRegister } from './components/TitleWrapperAvalistaRegister';

import { ShowPopUp } from './components/ShowPopup';

export default function AvalistaRegister() {
  const history = useHistory();
  const globalContext = useContext(CXT.Context);

  const [municipios, setMunicipios] = useState<any[]>([]);
  const [cliente, setCliente] = useState<any>(
    JSON.parse(localStorage.getItem('client') || '{}')
  );
  const [car, setCar] = useState<any>(undefined);
  const carData = JSON.parse(localStorage.getItem('car') || '{}');
  const parcel = JSON.parse(localStorage.getItem('parcel') || '{}');
  const [cpfAvalista, setCpfAvalista] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [avalista, setAvalista] = useState<any>(undefined);
  const isPessoaFisica = !!cliente?.cpf;

  useEffect(() => {
    if (
      !carData?.marcas?.[0]?.linhas?.[0]?.versoes?.[0]?.modelos?.[0]
        ?.veiculos?.[0] ||
      !parcel?.prazo
    ) {
      history.push('/client');
      return;
    }

    setCar(carData.marcas[0].linhas[0].versoes[0].modelos[0].veiculos[0]);

    findData
      .GetMunicipio()
      .then((response) => setMunicipios(response.data.data))
      .catch((err) => {
        toast.error('Erro ao carregar os municípios');
      });
  }, []);

  const cadastrarPedido = async (avalistaParam?: any) => {
    try {
      globalContext.setIsLoading(true);

      await validateEstoqueAndCustomer(
        cliente?.veiculoEstoqueId,
        cliente?.codPessoa,
        globalContext
      );

      await postPedido(
        car,
        parcel,
        cliente,
        globalContext,
        handleCheckId,
        avalistaParam?.id
      );
    } catch (error) {
      Bugsnag.notify(error as Error);
      toast.error('Erro ao cadastrar pedido');
    } finally {
      globalContext.setIsLoading(false);
    }
  };

  const handleFinishCadastroAvalista = (avalistaSubmitResponse: any) => {
    localStorage.setItem('avalista', JSON.stringify(avalistaSubmitResponse));
    setAvalista(avalistaSubmitResponse);
    cadastrarPedido(avalistaSubmitResponse);
  };

  const handleSubmitCpf = (cpf: string) => {
    setCpfAvalista(cpf);
    setShowForm(true);
  };

  const handleCheckId = (response: any) => {
    const dataResponse = response.data.data;

    if (dataResponse.status === 'OK') {
      globalContext.setIsLoading(false);
      history.push('/sucess');
    }

    if (dataResponse.status === 'NOK') {
      globalContext.setCodPropostaExistente(dataResponse.codPropostaExistente);

      switch (dataResponse.tipoValidacao) {
        case 'PROPOSTA_PARA_ATUALIZAR':
          globalContext.setPopUpActive([true, false, false, false]);
          globalContext.setIsLoading(false);
          break;
        case 'PROPOSTA_EM_ANALISE':
          globalContext.setPopUpActive([false, true, false, false]);
          globalContext.setIsLoading(false);
          break;
        case 'PROPOSTA_EM_ANDAMENTO':
          globalContext.setPopUpActive([false, false, true, false]);
          globalContext.setIsLoading(false);
          break;
        case 'PROPOSTA_RECUSADA':
          globalContext.setPopUpActive([false, false, false, true]);
          globalContext.setIsLoading(false);
          break;
        case 'LIMITE_PROPOSTAS_EM_ANDAMENTO':
          globalContext.setWarningData({
            title: 'AÇÃO INDISPONÍVEL',
            label: dataResponse.mensagemRetornoHtml ?? '',
            isVehicleName: false,
            isActive: true,
            outOfOrderVehicle: false,
            returnMessageVehicle: '',
          });
          globalContext.setIsLoading(false);
          break;
        default:
          globalContext.setIsLoading(false);
          toast.error(dataResponse.mensagem);
      }
    }
  };

  return (
    <>
      <Header />
      <S.Wrapper>
        <TitleWrapperAvalistaRegister />

        {!showForm && (
          <CpfCnpjInputSection
            title="CPF do Avalista"
            buttonLabel="Carregar cadastro"
            onSubmit={(cpf) => handleSubmitCpf(cpf)}
            onGoBack={() => history.goBack()}
            cpfOnly={true}
          />
        )}

        {showForm && cpfAvalista && (
          <PessoaFisicaForm
            key={`avalista-${cpfAvalista}`}
            role="avalista"
            customerCpf={cpfAvalista}
            municipios={municipios}
            stopLoadingOnFinish={false}
            submitButtonLabel="ENVIAR PARA CRÉDITO"
            finishCallback={handleFinishCadastroAvalista}
          />
        )}
      </S.Wrapper>
      <ShowPopUp handleCheckId={handleCheckId} />
    </>
  );
}
